import React, {InputHTMLAttributes} from "react"
import {i18n} from "../../i18n/i18n"
import CSS from "csstype"

export enum ConditionType {
    lowercase = "lowercase",
    uppercase = "uppercase",
    number = "number",
    symbol = "symbol",
    length = "length",
}

export const passwordInputSymbols = [
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")",
    "-",
    "_",
    "+",
    "=",
    ".",
    ",",
]

export const passwordSymbols = "( ! @ # $ % ^ & * ( ) - _ + = . , )"

export const getSymbolsValidation = () =>
    i18n.t("person:validation.password.need_one_symbol", {
        symbols: passwordSymbols,
    })

export const getPasswordConditions = (): Array<{
    id: ConditionType
    title: string
}> => [
    {
        id: ConditionType.lowercase,
        title: i18n.t("person:validation.password.need_one_lowercase"),
    },
    {
        id: ConditionType.uppercase,
        title: i18n.t("person:validation.password.need_one_uppercase"),
    },
    {
        id: ConditionType.number,
        title: i18n.t("person:validation.password.need_one_number"),
    },
    {
        id: ConditionType.symbol,
        title: getSymbolsValidation(),
    },
    {
        id: ConditionType.length,
        title: i18n.t("person:validation.password.characters_min_length", {count: 8}),
    },
]

export type ConditionsI = {
    [key in string]: {
        title: string
        isAccept: boolean
    }
}

export const getInitConditionsValue = () => {
    return getPasswordConditions().reduce(
        (acc: ConditionsI, item) => ({...acc, [item.id]: {isAccept: false, title: item.title}}),
        {}
    ) as ConditionsI
}

export interface InputWrapperProps {
    disabled?: boolean
    conditionsIsVisible?: boolean
    withoutUnderline?: boolean
    labelHtmlFor?: string
    className?: string
    fieldClassName?: string
    label?: string
    noTopPadding?: boolean
    labelCover?: boolean
    error?: string | boolean
    errorUnderline?: boolean
    warning?: string | boolean
    loader?: boolean
    style?: InputHTMLAttributes<HTMLInputElement>["style"]
    type?: InputHTMLAttributes<HTMLInputElement>["type"]
    fullWidth?: boolean
    miniSize?: boolean
    password?: boolean
    align?: "right"
    underlineChildren?: React.ReactNode
    name?: string
    inputClassName?: string
    value?: string
    validationDataTest?: string
    hideErrorText?: boolean
}

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, InputWrapperProps {
    value?: string
    mask?: string
    handleErrorMsg?: (error?: string) => string | undefined
    noErrorIfActive?: boolean
    active?: boolean
    inListNumber?: boolean
    withoutUnderline?: boolean
}

export interface TextAreaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
        Omit<InputWrapperProps, "value"> {
    maxHeight?: number
    autoFocus?: boolean
    _fixAutoExpandBug?: boolean // rare unclear bug
    textareaStyle?: CSS.Properties
}
